import { render, staticRenderFns } from "./move-log-dialog.vue?vue&type=template&id=48753dea&scoped=true&"
import script from "./move-log-dialog.vue?vue&type=script&lang=js&"
export * from "./move-log-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48753dea",
  null
  
)

export default component.exports